
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "WsrPreviewWidget1710463956",
      {"classes":{"root":"WsrPreviewWidget1710463956__root","previewWidgetRoot":"WsrPreviewWidget1710463956__previewWidgetRoot","previewWidgetContainer":"WsrPreviewWidget1710463956__previewWidgetContainer"},"vars":{"containerOutline":"--containerOutline"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  